<ng-template #template let-i>
  <ng-container [formGroup]="i">
    <input formControlName="id" type="hidden" />

    <pr-input [label]="'Valeur'" [suffix]="'€'" [derrors]="derrors"
      ><input formControlName="amount" type="text"
    /></pr-input>

    <pr-input-date
      formControlName="date"
      label="Date de l'estimation"
      [derrors]="derrors"
    ></pr-input-date>
  </ng-container>
</ng-template>

<div [formGroup]="form">
  <ul formArrayName="array">
    <pr-form-list-item
      *ngFor="let item of array.controls as FormGroup; let i = index"
      [formGroup]="item"
      [index]="i"
      headerClass="horizontal-title-list-item"
      buttonIconVbWidth="23"
      buttonIconVbHeight="23"
      buttonStyle="label"
      buttonClass="btn-nostyle neutral btn-list-remove"
      itemName="cette valorisation"
      [context]="this"
      [derrors]="derrors"
      (onDelete)="eaEstimationFormService.removeElem($event, array, entity)"
      (onValidate)="validate(item)"
    >
      @if (item.get('amount').value) {
        @if (item.get('date').value) {
          <div class="pr-form-list-title-primary">
            Valorisation {{ getMonth(item.get('date').value) }}
          </div>
        }
        <div>
          {{ item.get('amount').value | currency: 'EUR' : 'symbol' : '.0-0' }}
        </div>
        @if (item.get('date').value && item.get('date').status === 'VALID') {
          <div class="pr-form-list-title-tertiary">
            Estimation
            {{ item.get('source').value === 'user' ? 'Manuelle' : 'Auto' }}
          </div>
        }
      } @else {
        <div class="pr-form-list-title-primary">Nouveau montant</div>
      }
      <ng-container
        item
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ $implicit: item }"
      ></ng-container>
    </pr-form-list-item>
    @if (derrors && form.controls.errors) {
      <ul class="pr-form-list-errors">
        @if (form.controls.errors) {
          <li>Vous devez declarer au moins un montant</li>
        }
      </ul>
    }
    <div class="pr-form-list-add">
      <pr-button
        label="Ajouter une valorisation"
        rightIcon="sp-plus"
        clazz="btn-list-add neutral"
        (onClick)="eaEstimationFormService.addElem(entity, form.controls)"
      >
      </pr-button>
    </div>
  </ul>
</div>
